export default "__VITE_ASSET__v0771Uw5__"